module.exports = __webpack_public_path__ + "img/img-35ee45.png";